import React from 'react';
import { Cloudinary } from '@cloudinary/url-gen';
import { AdvancedImage } from '@cloudinary/react';
import { scale } from '@cloudinary/url-gen/actions/resize';
import { trim } from '@cloudinary/url-gen/actions/reshape';

export type CompanyLogoProps = {
  logoText: string;
  logoPublicId?: string;
};

const CompanyLogo: React.FC<CompanyLogoProps> = ({
  logoText,
  logoPublicId,
}: CompanyLogoProps) => {
  const cl = new Cloudinary({ cloud: { cloudName: 'volusion-v1' } });
  const logoImage = cl.image(logoPublicId);
  logoImage
    .resize(scale().height(130).width('auto'))
    .reshape(trim().colorOverride('white').colorSimilarity(1));
  return (
    <div className="text-left md:text-center w-7/12 md:w-full">
      <a href="/">
        {logoPublicId ? (
          <AdvancedImage cldImg={logoImage} />
        ) : (
          <span className="logo-font checkout-panel-section-header text-2xl sm:text-3xl ml-1">
            {logoText}
          </span>
        )}
      </a>
    </div>
  );
};

export default CompanyLogo;
